import { render } from "./Informing.vue?vue&type=template&id=af1d9b8e&scoped=true"
import script from "./Informing.vue?vue&type=script&lang=js"
export * from "./Informing.vue?vue&type=script&lang=js"

import "./Informing.vue?vue&type=style&index=0&id=af1d9b8e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/Mosolysziget/Mosolysziget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1d9b8e"]])

export default __exports__